import { render, staticRenderFns } from "./ClientsReports.vue?vue&type=template&id=16ebadad&"
import script from "./ClientsReports.vue?vue&type=script&lang=js&"
export * from "./ClientsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports